module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      F. Paul Wilson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("F. Paul Wilson is the author of more than fifty books spanning various genres, including science fiction, horror, thriller, and more. Four of his novels have been "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestsellers, and his work has earned him four Prometheus Awards, the prestigious Inkpot Award from the San Diego Comic-Con, and the Pioneer Award from the RT Booklovers Convention.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KHdkBw/tc-custom/9781429967365.jpg?1737775547048",
      "alt": "This image is the cover for the book Conspiracies, Repairman Jack"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Conspiracies, Repairman Jack\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Repairman Jack, F. Paul Wilson's vigilante hero from the "), _c('i', [_vm._v("New York Times ")]), _vm._v("bestseller "), _c('i', [_vm._v("The Tomb")]), _vm._v(", returns in a thriller that thrusts him back into the weird, supernatural world that he thrives in."), _c('br'), _c('br'), _vm._v("Looking for clues to the mysterious disappearance of leading conspiracy theorist Melanie Ehler, Jack attends a convention of bizarre and avid conspiracy theorists. It's a place where aliens are real, the government is out to get you, and the world is hurtling toward an inevitable war of good versus evil incarnate."), _c('br'), _c('br'), _vm._v("Jack finds that nobody can be trusted--and that few people are what they seem. Worse yet, Jack's been having vivid dreams that make him wonder whether he's headed for a clash with his own past--maybe "), _c('i', [_vm._v("The Tomb")]), _vm._v("'s evil rakoshi beasts aren't through with him quite yet."), _c('br'), _c('br'), _c('br'), _vm._v("At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0